import { BUTTON_SELECTOR } from '@ardoq/button';
import { colors, s4 } from '@ardoq/design-tokens';
import { FlexBox } from '@ardoq/layout';
import styled from 'styled-components';

export const ViewSelectorBarWrapper = styled(FlexBox).attrs({
  align: 'stretch',
  gap: 'medium',
})`
  border-bottom: 1px solid ${colors.borderAction};

  & > ${BUTTON_SELECTOR} {
    margin: ${s4};
    width: 48px;
    height: auto;
    flex: 0;
  }
`;
